// extracted by mini-css-extract-plugin
export default {"ScanQR":"ScanQR_ScanQR__MTlkY","ScanQR__leftColumn":"ScanQR_ScanQR__leftColumn__YTQ0N","ScanQR__rightColumn":"ScanQR_ScanQR__rightColumn__NWQzY"};